import { Text } from '@doordash/design-language'
import * as React from 'react'
import { isWebview } from '../../../utilities/userAgent'
import { loadUrl } from '../../../webview'

export const CommonTextUrl = props => {
  let textProps = props.textProps || {}

  if (isWebview() && !props.openInBrowser) {
    const onClick = () => {
      loadUrl(props.url)
    }
    textProps = {
      ...textProps,
      onClick,
    }
  } else {
    textProps = {
      ...textProps,
      target: '_blank',
      href: props.url,
    }
  }

  return (
    <Text
      textDecoration="none"
      display={Text.DisplayModes.Inline}
      styles={Text.Styles.SectionSubtext}
      color={Text.Colors.SystemRed60}
      tag={'a'}
      {...textProps}
    >
      {props.children}
    </Text>
  )
}
